
class ThemeInput extends HTMLElement {
  input; type; required; error; errorLabel; valid;
  static selectors = {
    error: '[data-error]'
  };
  static classes = {
    error: 'is-invalid'
  };

  constructor(){
    super();
    this.init();
  }

  init = () => {
    this.input = this.querySelector('input,textarea,select');
    this.errorLabel = this.querySelector(ThemeInput.selectors.error);

    this.type = this.input.type === undefined ? this.input.tagName.toLowerCase() : this.input.type.toLowerCase();
    this.required = this.input.getAttribute('required') != undefined;

    this.input.addEventListener('blur', () => {
      this.isValid();
    });
    this.input.addEventListener('change', () => {
      this.isValid();
    });
    this.input.addEventListener('focus', () => {
      this.clearErrors();
    });
  }

  isValid = () => {
    this.valid = true;
    this.isValidEmpty();
    this.isValidEmail();
    this.setError();
    return this.valid;
  }

  isValidEmpty = () => {
    var valid = this.valid;
    if(this.required){
      valid = this.input.value != undefined && this.input.value != null && this.input.value.trim() != '' && this.input.value.trim().length > 0;
      this.error = window.lang.errors.required;
    } 
    this.valid = valid;
    return valid;
  }

  isValidEmail = () => {
    if(this.type.localeCompare('email') === 0 && this.isValidEmpty()){
      this.valid = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(this.input.value);
      this.error = window.lang.errors.email;
    } 
    return this.valid;
  }

  setError = () => {
    if(this.valid){
      this.clearErrors();
    } else {
      this.errorLabel.innerText = this.error;
      this.classList.add(ThemeInput.classes.error);
    }
  }

  clearErrors = () => {
    this.errorLabel.innerText = '';
    this.classList.remove(ThemeInput.classes.error);
  }
}
if (!window.customElements.get("theme-input")) {
  window.customElements.define("theme-input", ThemeInput);
}